import { CarouselSection } from '../../../elements/sections/CarouselSection/CarouselSection'
import { FilmBannerContent } from '../../content/FilmBannerContent/FilmBannerContent'
import { ListContainer } from '../ListContainer'

const tabletLayout = {
  maxHeight: 0.8,
  gradient: { x: 0, y: -0.6, strength: 30 },
}
const responsive = {
  xs: {
    maxHeight: 0.9,
    gradient: { x: 0, y: -0.55, strength: 30 },
  },
  sm: tabletLayout,
  md: tabletLayout,
  lg: {
    maxHeight: 0.8,
    gradient: { x: 0.6, y: 0, strength: 30 },
  },
}

export const BannerContent = ({ slug, loading, error, items, headerOffset, isFocused }) => {
  return (
    <ListContainer>
      <CarouselSection
        fadeDelay={5000}
        error={error}
        loading={loading}
        showActivityIndicator
        scrollPositionSlug={slug}
        headerOffset={headerOffset}
        responsive={responsive}
        mdPreferLandscape={false}
        justify="flex-end"
        items={items}
        renderItem={({ item, height }) => <FilmBannerContent item={item} minHeight={height} />}
        autoScroll={isFocused}
      />
    </ListContainer>
  )
}
